// extracted by mini-css-extract-plugin
export var bgImage = "sectionFeature-module--bgImage--wiK5G";
export var columns = "sectionFeature-module--columns--DwMeC";
export var content = "sectionFeature-module--content--bYLos";
export var description = "sectionFeature-module--description--TuNcF";
export var highlighted = "sectionFeature-module--highlighted--xSPDc";
export var image = "sectionFeature-module--image--tpcUT";
export var imageWrapper = "sectionFeature-module--image-wrapper--66Olt";
export var images = "sectionFeature-module--images--JzkS8";
export var imagesMargin = "sectionFeature-module--images-margin--mDcBV";
export var section = "sectionFeature-module--section--ofRoc";
export var sectionWithNoMargine = "sectionFeature-module--section-with-no-margine--Z+pIF";
export var withBg = "sectionFeature-module--with-bg--J7sip";
export var wrapper = "sectionFeature-module--wrapper--jTQIW";